webpackJsonp([9],{

/***/ "2/wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("p", [
        _vm._v(" 苏州亿数腾云科技有限公司 版权所有 [苏ICP备18063955号-1] ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-957a3b30", esExports)
  }
}

/***/ }),

/***/ "6y/E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("UTlt")(false);
// imports


// module
exports.push([module.i, "\n.theme-base[data-v-957a3b30] {\n  --base: #fff;\n  --base-2: #339AF0;\n  --base-3: #f3f3f3;\n  --base-4: #F1723F;\n  --base-5: #F388AD;\n  --base-6: #B58C71;\n  --base-7: #bcc0c7;\n  --base-8: #597eca;\n  --base-9: #b6c5e4;\n  --base-10: #b53e3e;\n  --base-11: #C3E989;\n  --base-12: #FCC419;\n  --base-13: #676b6d8a;\n  --base-14: #5b7b2b;\n  --base-15: #E9EAEB;\n  --base-16: #27b238;\n  --base-17: #aebcca;\n  --base-18: #7ebf1b;\n  --base-19: #51CF66;\n  --base-20: #28B339;\n  --base-21: rgba(0, 0, 0, 0.4);\n  --base-22: #15185f;\n  --font-color: #2c3e50;\n  --input-color: #81858c;\n}\n.moble-app .theme-base[data-v-957a3b30] {\n  --d-mini-0: 0.1rem;\n  --c-mini-0: 0.15rem;\n  --b-mini-0: 0.18rem;\n  --a-mini-0: 0.2rem;\n  --mini-0: 0.22rem;\n  --mini: 0.25rem;\n  --small-0: 0.28rem;\n  --small: 0.3rem;\n  --small-2: 0.35rem;\n  --default-size: 0.4rem;\n  --big: 0.45rem;\n  --large: 0.5rem;\n  --large-2: 0.6rem;\n  --large-3: 0.7rem;\n  --large-4: 0.8rem;\n  --large-5: 1rem;\n}\n.pc-app .theme-base[data-v-957a3b30] {\n  --mini: 12px;\n  --small: 16px;\n  --large: 26px;\n}\n.pc-app .bottom[data-v-957a3b30] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: var(--base-22);\n  height: 200px;\n  color: var(--base);\n}\n.moble-app .bottom[data-v-957a3b30] {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: var(--base-22);\n  height: 1rem;\n  color: var(--base);\n}\n.moble-app .bottom p[data-v-957a3b30] {\n    font-size: 0.02rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "B8hT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XNb3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_957a3b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("2/wd");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ZY+v")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-957a3b30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_957a3b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/common/bottom/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-957a3b30", Component.options)
  } else {
    hotAPI.reload("data-v-957a3b30", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XNb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__script_js__ = __webpack_require__("uMmp");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__script_js__["a" /* default */]);

/***/ }),

/***/ "ZY+v":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6y/E");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("FIqI")("46af460e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/_css-loader@0.28.11@css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-957a3b30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!../../../../node_modules/_sass-resources-loader@2.2.4@sass-resources-loader/lib/loader.js?{\"resources\":[\"G:\\\\文档\\\\web\\\\yes-cloud-web\\\\src\\\\resource\\\\css\\\\variable\\\\index.scss\"]}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/_css-loader@0.28.11@css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-957a3b30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!../../../../node_modules/_sass-resources-loader@2.2.4@sass-resources-loader/lib/loader.js?{\"resources\":[\"G:\\\\文档\\\\web\\\\yes-cloud-web\\\\src\\\\resource\\\\css\\\\variable\\\\index.scss\"]}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uMmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bottom',
  components: {},
  data: function data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },

  methods: {
    handleSelect: function handleSelect() {}
  },
  // 计算属性
  computed: {},
  created: function created() {}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.902631050d98aec6a33c.js